import React from "react";
import { useDispatch } from "react-redux";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NoResultsScreen from "src/app/components/NoResultsScreen/NoResultsScreen";
import noFilteredResultsImg from "src/images/empty-folder-group.svg";
import { setSelectedFilters } from "src/redux";

export default function NoListResults() {
  const dispatch = useDispatch();
  return (
    <div className="no-filtered-results-screen-wrapper">
      <NoResultsScreen
        title={
          <IDHFormattedMessage
            id="ws_no_results_found"
            defaultMessage="No results found"
          />
        }
        subtitle={
          <IDHFormattedMessage
            id="ws_remove_filters"
            defaultMessage="No results match the filter criteria. Remove filter or clear all filters to show results."
          />
        }
        imgUrl={noFilteredResultsImg}
        bottomContent={
          <Button
            size="large"
            variant="blue"
            onClick={() => dispatch(setSelectedFilters({}))}
          >
            <IDHFormattedMessage
              id="ws_clear_filters"
              defaultMessage="Clear filters"
            />
          </Button>
        }
      />
    </div>
  );
}
